import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Context menu component for form questions.
 * Provides actions like sort, delete, add, and edit.
 * Uses Angular signals for inputs and outputs.
 */
@Component({
  selector: 'app-form-context-menu',
  standalone: true,
  imports: [],
  templateUrl: './form-context-menu.component.html',
  styleUrl: './form-context-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormContextMenuComponent {
  readonly questionId = input<string>();
  readonly showSortAndDelete = input(true);
  readonly isEditing = input<boolean>(true);
  readonly hasQuestionType = input(false);

  readonly sort = output<void>();
  readonly delete = output<void>();
  readonly insertBelow = output<void>();
  readonly dragStart = output<DragEvent>();
  readonly dragEnd = output<void>();
  readonly accept = output<void>();
  readonly edit = output<void>();

  handleSort(): void {
    this.sort.emit();
  }

  handleDelete(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.delete.emit();
  }

  handleInsertBelow(): void {
    this.insertBelow.emit();
  }

  onDragStart(event: DragEvent): void {
    // Prevent default to ensure drag works properly
    event.stopPropagation();
    const questionIdValue = this.questionId();
    if (event.dataTransfer && questionIdValue !== undefined) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', questionIdValue);
    }
    // Emit to parent so it can track the dragged question
    this.dragStart.emit(event);
  }

  onDragEnd(): void {
    // Emit to parent to reset dragged question state
    this.dragEnd.emit();
  }

  handleAccept(): void {
    this.accept.emit();
  }

  handleEdit(): void {
    this.edit.emit();
  }
}

